import React, { useState, useEffect, useRef, useCallback } from "react";
import { IoMdSearch } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import DropDownComp from "./DropDownComp";
import { useSearchAllQuery } from "./Searchallapislice";
import debounce from "lodash.debounce";
import { RiAddLargeFill } from "react-icons/ri";
import { RiBarChartBoxLine } from "react-icons/ri";
import { FaRegFolderOpen } from "react-icons/fa6";
import { FiDatabase } from "react-icons/fi";
import LoadingIndicator from "./BasicComponents/LoadingIndicator";
export default function HomeHeader(props) {
  const [searchQuery, setSearchQuery] = useState("");
  // // console.log(searchQuery);
  const searchBoxRef = useRef(null);
  const { roles } = useAuth();
  const navigate = useNavigate();
  const userCompanyDetails = JSON.parse(
    localStorage.getItem("userCompanyDetails")
  );

  const userName = userCompanyDetails?.name;

  // Use debounce to delay the search query update
  const debouncedSearch = useCallback(
    debounce((query) => {
      setSearchQuery(query);
    }, 300),
    []
  );

  const { data: searchResults = [], isLoading } = useSearchAllQuery(
    searchQuery,
    {
      skip: searchQuery.length === 0, // Skip fetching if search query is empty
    }
  );

  const filteredFolders =
    searchResults["folders"] !== undefined &&
    searchResults["folders"].length
      ? searchResults["folders"]
      : [];

  const filteredGroups =
    searchResults["groups"] !== undefined && searchResults["groups"].length
      ? searchResults["groups"]
      : [];

  const filteredWorkbooks =
    searchResults["workbooks"] !== undefined &&
    searchResults["workbooks"].length
      ? searchResults["workbooks"]
      : [];

  const filteredDataSources =
    searchResults["dataSources"] !== undefined &&
    searchResults["dataSources"].length
      ? searchResults["dataSources"]
      : [];

  const onNewButtonClicked = () => {
    navigate("/datasource");
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchBoxRef.current &&
        !searchBoxRef.current.contains(event.target)
      ) {
        setSearchQuery("");
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  let NewButton = null;
  if (
    roles.includes("Admin") ||
    roles.includes("Creator") ||
    roles.includes("Explorer")
  ) {
    NewButton = (
      <button
        className="shadow shadow-gray-300 w-auto rounded h-full px-3 text-[15px] gap-1 border-none bg-blue-950 text-white flex items-center justify-center font-light"
        onClick={onNewButtonClicked}
      >
        <RiAddLargeFill className="text-white text-md" /> New
      </button>
    );
  }

  const handleInputChange = (event) => {
    const query = event.target.value;
    // // console.log(query);
    debouncedSearch(query);
  };
  // // console.log(searchResults);

  // // console.log(filteredFolders);

  // // console.log(filteredWorkbooks);

  // // console.log(filteredDataSources);

  const handleConnectWorkbook = () => {};

  const handleOpenWorkbook = (workbookId, sheetId) => {
    // // console.log(workbookId);
    // // console.log(sheetId);
    navigate(`/home/viewworkbook/${workbookId}/sheetId?=${sheetId}`);
    setSearchQuery("");
  };
  const handleOpenFolder = (folderPath) => {
    navigate(`/home/dash/library/${folderPath}`);
    setSearchQuery("");
  };

  const searchQueryContainerHeight =
    searchResults !== undefined &&
    (filteredFolders.length > 10 ||
      filteredWorkbooks.length > 10 ||
      filteredDataSources.length > 10)
      ? "h-[20rem] overflow-y-auto overflow-hidden"
      : "h-auto";
  // // console.log(searchQueryContainerHeight);

  return (
    <header className="bg-white py-1 rounded shadow flex justify-center px-2 h-[6vh] min-h-auto max-h-auto w-full items-center">
      <aside className="flex justify-start items-center gap-1 w-1/2">
        {userName ? (
          <h3 className="font-[500] w-auto">
            {props.title} {userName},
          </h3>
        ) : (
          <h3 className="font-[500] w-auto">{props.title}</h3>
        )}

        <div className="w-auto flex flex-col gap-2 items-start justify-center relative">
          <button
            className={`flex justify-start items-center rounded border border-gray-300 text-gray-800 shadow gap-1 px-1 py-[1px] h-full w-auto`}
          >
            <IoMdSearch className="text-gray-400" />
            <input
              className={`w-[15.8rem] placeholder:text-[12px] pb-[4px] focus:outline-none text-sm`}
              type="text"
              placeholder="search for folders, workbooks, dataSources etc."
              onChange={handleInputChange}
            />
          </button>
          {searchQuery !== "" && searchQuery && (
            <div
              className={`absolute z-40 bg-white border border-gray-300 rounded shadow-md top-[130%] w-full ${searchQueryContainerHeight}`}
            >
              {isLoading ? (
                <LoadingIndicator />
              ) : filteredFolders.length ||
                filteredWorkbooks.length ||
                filteredDataSources.length ? (
                <div className="w-full flex flex-col gap-[2px] items-start justify-center">
                  {/* Display Folders */}
                  {filteredFolders.map((folder, index) => (
                    <button
                      key={index}
                      className="flex gap-1 w-full items-center justify-start hover:bg-gray-200 border-none rounded pl-[6px]"
                      onClick={() => handleOpenFolder(folder._id)}
                    >
                      <FaRegFolderOpen />
                      {folder.name}
                    </button>
                  ))}

                  {/* Display Workbooks */}
                  {filteredWorkbooks.map((workbook, index) => (
                    <button
                      key={index}
                      className="flex gap-1 w-full items-center justify-start hover:bg-gray-200 border-none rounded pl-[6px]"
                      onClick={() =>
                        handleOpenWorkbook(
                          workbook._id,
                          workbook.selectedSheetId
                        )
                      }
                    >
                      <RiBarChartBoxLine />
                      {workbook.name}
                    </button>
                  ))}

                  {/* Display Data Sources */}
                  {filteredDataSources.map((dataSource, index) => (
                    <button
                      key={index}
                      className="flex gap-1 w-full items-center justify-start hover:bg-gray-200 border-none rounded pl-[6px]"
                      onClick={() => handleConnectWorkbook(dataSource._id)}
                    >
                      <FiDatabase />
                      {dataSource.name}
                    </button>
                  ))}
                </div>
              ) : (
                <div className="p-2">No results found</div>
              )}
            </div>
          )}
        </div>
      </aside>
      <aside className="flex justify-end items-center gap-3 w-1/2">
        {NewButton}
        <DropDownComp />
      </aside>
    </header>
  );
}
